import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, _ } from "gridjs-react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Card, CardBody, CardHeader, Col, Container, Row, Button, Modal, ModalBody, ModalHeader, ButtonToolbar, Input } from "@/Components/ui";
;
import { BACKEND_HOST } from "../../../api";
import { SUBDOMAIN } from "../../../assets/meta/meta";
import qs from "qs";
import { useAuthContext } from "../../../Components/AuthContext";
import { API, IS_TEST } from "../../../api/client";
import { dialogService } from "@/utils/dialogService";
export default function SupplyCart() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [fields, setFields] = useState([]);
    const [delRecord, setDelRecord] = useState(null);
    const [modalDelete, setModalDelete] = useState(false);
    const { userInfo } = useAuthContext();
    function tog_delete() {
        setModalDelete(!modalDelete);
    }
    const checkedAllBtn = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");
        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        }
        else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };
    useEffect(() => {
        fetchData();
    }, []);
    const deleteData = (product_id) => {
        API.delete(`${BACKEND_HOST}/supply/cart/${product_id}`)
            .then(async (response) => {
            console.log(response);
            if (response.status === 200) {
                console.log("삭제 성공");
                await dialogService.handleAlert("삭제 완료되었습니다.");
            }
            else {
                console.log("삭제 실패");
            }
        })
            .catch((e) => console.log(e));
    };
    const handlePreorder = ({ postData, amount, orderName }) => {
        console.log("handle pre order:", orderName, amount);
        console.log("pre order body:", postData);
        API.post(`${BACKEND_HOST}/supply/preorder/`, postData)
            .then((res) => {
            const data = res.data;
            console.log("/supply/preorder/", data);
            console.log("userInfo", userInfo);
            // id, 이름, 전화번호
            const subdomain = SUBDOMAIN;
            const _queryparams = {
                subdomain: subdomain,
                // clientKey: "live_ck_GePWvyJnrKb95K72DjRVgLzN97Eo", 
                clientKey: "test_ck_AQ92ymxN349Xj9J2QQgVajRKXvdk",
                variantKey: "amazingpay_ulsan",
                orderName: orderName,
                description: "주문 상품",
                username: userInfo.username,
                phone_num: userInfo.phone_num,
                user_id: userInfo.id,
                amount: amount,
                order_id: data.orderId,
                success_url: `${BACKEND_HOST}/supply/order/`,
                fail_url: `https://${subdomain}crm.${window.AMZ_ENV.REACT_APP_DOMAIN}/supply/order/failed/`,
            };
            _queryparams.show_button = true;
            _queryparams.show_info = true;
            if (IS_TEST)
                _queryparams.debug = true;
            const _url = `${BACKEND_HOST}/accounts/render-brandpay/?${qs.stringify(_queryparams)}`;
            window.open(_url, "_self");
        })
            .catch((e) => console.log(e));
    };
    const fetchData = () => {
        API.get(`${BACKEND_HOST}/supply/cart/`)
            .then((res) => {
            const data = res.data;
            console.log("data", data);
            const fieldName = Object.keys(data[0]);
            const fieldList = [``, "id", "thumbnail", "name", "price", "stock_count", "quantity"];
            // let tmpFields = getFields(fieldName);
            let tmpFields = [
                {
                    // id: "checkboxColumn", // 열의 ID를 설정합니다.
                    // name: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
                    formatter: (cell) => _(<input type="checkbox" className="customerCheckBox form-check-input"/>),
                },
                {
                    name: "id",
                    formatter: (cell) => _(<span style={{ whiteSpace: "pre-line" }} className="fw-semibold">
                  {cell}
                </span>),
                },
                {
                    name: "thumbnail",
                    formatter: (cell) => _(<img src={cell} alt="상품 사진" style={{ maxWidth: "100px", maxHeight: "100px" }}/>),
                },
                {
                    name: "name",
                    formatter: (cell) => _(<span style={{ whiteSpace: "pre-line" }} className="fw-semibold">
                  {cell}
                </span>),
                },
                {
                    name: "price",
                    formatter: (cell) => _(<span style={{ whiteSpace: "pre-line" }} className="fw-semibold">
                  {cell}
                </span>),
                },
                {
                    name: "stock_count",
                    formatter: (cell) => _(<span style={{ whiteSpace: "pre-line" }} className="fw-semibold">
                  {cell}
                </span>),
                },
                {
                    name: "quantity",
                    width: "140px",
                    formatter: (cell, row) => _(<QuantityBox count={cell} id={row._cells[1].data} productId={data.find((product) => product.id === row._cells[1].data).supply_product.id}/>),
                },
            ];
            tmpFields.push({
                name: "Actions",
                width: "170px",
                formatter: (cell, row) => _(<div className="d-flex gap-2">
                <div className="supply">
                  <Button data-bs-toggle="modal" data-bs-target="#deleteRecordModal" onClick={() => {
                        // navigate(`/ticket-product-form/${cell}`);
                        let quantity_input = document.querySelector(`#supply_product_${row._cells[1].data}`);
                        let supply_product_id = data.find((product) => product.id === row._cells[1].data).supply_product.id;
                        const postData = {
                            cart_data: [
                                {
                                    supply_product: supply_product_id,
                                    variation: null,
                                    quantity: parseInt(quantity_input.value),
                                },
                            ],
                        };
                        handlePreorder({
                            postData,
                            amount: data.find((product) => product.id === row._cells[1].data).supply_product.price * parseInt(quantity_input.value),
                            orderName: data.find((product) => product.id === row._cells[1].data).supply_product.name,
                        });
                    }} color="success" size="sm" className="edit-item-btn">
                    주문
                  </Button>
                </div>

                <div className="supply">
                  <Button data-bs-toggle="modal" data-bs-target="#deleteRecordModal" onClick={() => {
                        const cart_id = row._cells[1].data;
                        let quantity_input = document.querySelector(`#supply_product_${row._cells[1].data}`);
                        let supply_product_id = data.find((product) => product.id === row._cells[1].data).supply_product.id;
                        const postData = {
                            supply_product: supply_product_id,
                            quantity: parseInt(quantity_input.value),
                        };
                        console.log("postData", JSON.stringify(postData));
                        API.put(`${BACKEND_HOST}/supply/cart/${cart_id}/`, postData)
                            .then(async (data) => {
                            console.log(data);
                            await dialogService.handleAlert("수정되었습니다.");
                        })
                            .catch((e) => console.log(e));
                    }} color="primary" size="sm" className="edit-item-btn">
                    수정
                  </Button>
                </div>

                <div className="remove">
                  <Button data-bs-toggle="modal" data-bs-target="#deleteRecordModal" onClick={() => {
                        // console.log(row._cells[1].data);
                        const product_id = row._cells[1].data;
                        API.delete(`${BACKEND_HOST}/supply/cart/${product_id}`)
                            .then(async (response) => {
                            console.log(response);
                            if (response.status === 200) {
                                console.log("삭제 성공");
                                await dialogService.handleAlert("삭제 완료되었습니다.");
                                fetchData();
                            }
                            else {
                                console.log("삭제 실패");
                            }
                        })
                            .catch((e) => console.log(e));
                    }} color="danger" size="sm" className="remove-item-btn">
                    삭제
                  </Button>
                </div>
              </div>),
            });
            setFields(tmpFields);
            // let dataArr = getDataList(data);
            let dataArr = [];
            data.forEach((item) => {
                console.log("items", item);
                let itemValues = [];
                fieldList.forEach((field) => {
                    if (field === "id" || field === "quantity") {
                        itemValues.push(item[field]);
                    }
                    else {
                        itemValues.push(item.supply_product[field]);
                    }
                });
                itemValues.push(item.id);
                dataArr.push(itemValues);
            });
            setData(dataArr);
        })
            .catch((e) => console.log(e));
    };
    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="장바구니" pageTitle="발주"/>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <h4 className="card-title mb-0 flex-grow-1">발주상품 장바구니</h4>
                  <div></div>
                </CardHeader>

                <CardBody>
                  <div style={{ display: "flex", alignItems: "center", float: "right" }}>
                    <span style={{ marginRight: "10px", fontSize: "15px" }}>전체 선택</span>
                    <input style={{ width: "20px", height: "20px" }} type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAllBtn()}/>
                    <div className="supply">
                      <Button style={{ marginLeft: "30px" }} data-bs-toggle="modal" data-bs-target="#deleteRecordModal" onClick={async () => {
            let orderData = [];
            const checked_input = document.querySelectorAll(".customerCheckBox:checked");
            let amount = 0;
            let orderName = "";
            checked_input.forEach((input) => {
                const parentRow = input.closest(".gridjs-tr");
                const supplyProductInput = parentRow.querySelector(".supply_product_input");
                const supplyProductInput_id = supplyProductInput.classList[1].split("_")[2];
                const supplyProductInput_quantity = supplyProductInput.value;
                // console.log("supplyProductInput id", supplyProductInput.id.split("_")[2]);
                let postObj = {
                    supply_product: parseInt(supplyProductInput_id),
                    variation: null,
                    quantity: parseInt(supplyProductInput_quantity),
                };
                orderData.push(postObj);
                const cart_item = data.find((product) => product[1] === parseInt(supplyProductInput.id.split("_")[2]));
                // console.log("data", data);
                // console.log("cart_item", cart_item);
                if (cart_item) {
                    amount += cart_item[4] * parseInt(supplyProductInput_quantity);
                    orderName += cart_item[3] + " ";
                }
            });
            if (orderData.length > 0) {
                const postData = {
                    cart_data: orderData,
                };
                handlePreorder({
                    postData,
                    amount: amount,
                    orderName: orderName,
                });
            }
            else {
                await dialogService.handleAlert("주문하실 상품을 선택해 주세요.");
            }
        }} color="secondary" className="me-1">
                        선택 주문
                      </Button>
                    </div>
                  </div>
                  <div id="table-gridjs">
                    <Grid data={data} columns={fields} search={true} sort={true} pagination={{ enabled: true, limit: 10 }}/>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>);
}
const QuantityBox = ({ count, id, productId }) => {
    const [quantity, setQuantity] = useState(count);
    console.log("productId", productId);
    const decreaseCount = () => {
        if (quantity === "") {
            setQuantity(0);
        }
        if (quantity > 0) {
            setQuantity((prev) => prev - 1);
        }
    };
    const increaseCount = () => {
        if (quantity === "") {
            setQuantity(0);
        }
        setQuantity((prev) => prev + 1);
    };
    const handleInputChange = (event) => {
        setQuantity("");
        const newQuantity = parseInt(event.target.value);
        console.log(newQuantity);
        console.log("state", quantity);
        if (!isNaN(newQuantity)) {
            setQuantity("");
            setQuantity(newQuantity);
        }
        else {
            setQuantity("");
        }
    };
    useEffect(() => {
        setQuantity(count);
    }, [count]);
    return (<span>
      <ButtonToolbar>
        <Button color="light" onClick={() => decreaseCount()}>
          -
        </Button>
        <Input id={`supply_product_${id}`} className={`supply_product_input supply_product_${productId}`} type="number" style={{ width: "100px" }} value={quantity} onChange={handleInputChange}/>
        <Button color="light" onClick={() => increaseCount()}>
          +
        </Button>
      </ButtonToolbar>
    </span>);
};
